import {getAll,
    addIndex,
    editIndex,
    getIndexDetail,
    getBank,
    getAllCategory,
    addCategory,
    editCategory,
    deleteCategory,
    deleteIndex,
    acceptIndex,
    getAllCategoriesTenantId
} from '../Api/Index';
import { useQuery, useQueryClient, useMutation } from "react-query";

type option = {
    id: string;
    name: string;
  };

const useGetAll=(tenantId: string | null)=>{
    return useQuery(['getAll', tenantId],getAll,{
      enabled: !!tenantId,
        refetchOnWindowFocus:false,
        cacheTime:Infinity,
        onError:(err)=>{
        },
        onSuccess:(data)=>{
            // let rawdata=data?.data?.data;
        }
        ,
        select:(data)=>{
            let rawdata=data?.data;
             return rawdata
        }
    })
}

const useGetAllCategory=(tenantId: string | null)=>{
  return useQuery(['getAllCategory', tenantId],getAllCategory,{
    enabled: !!tenantId,
      refetchOnWindowFocus:false,
      cacheTime:Infinity,
      onError:(err)=>{
      },
      onSuccess:(data)=>{
          // let rawdata=data?.data?.data;
      }
      ,
      select:(data)=>{
          let rawdata=data?.data;
           return rawdata
      }
  })
}

const useAddIndex=()=>{
    const queryClient=useQueryClient()
    return useMutation({
  mutationFn: (userData:any) =>addIndex(userData),
  onSuccess: (data:any) => {
    queryClient.invalidateQueries('getAll')
  },
});
   }

   const useEditIndex=()=>{
    const queryClient=useQueryClient()
    return useMutation({
  mutationFn: (userData:any) =>editIndex(userData),
  onSuccess: (data:any) => {
    queryClient.invalidateQueries('getAll')
  },
});
   }

//    const useGetIndexDetail=(userData:any)=>{
//     // const queryClient=useQueryClient()
//     return useMutation({
//   mutationFn: () =>getIndexDetail(userData),
//   onSuccess: (data:any) => {
//     let rawData = data?.data;
//           // let tranFormed;
//           // if (rawData) {
//           //   tranFormed = rawData.map(({ name, id }: option) => {
//           //     return { key: name, value: id };
//           //   });
//           // }
//           return rawData;
//   },
// });
//    }

// const useGetIndexDetail=(tenantId: string | null)=>{
//   return useQuery(['getAllCategoriesTenantId', tenantId],getAllCategoriesTenantId,{
//     enabled: !!tenantId,
//       refetchOnWindowFocus:false,
//       cacheTime:Infinity,
//       onError:(err)=>{
//       },
//       onSuccess:(data)=>{
//           let rawdata=data?.data?.data;
//       }
//       ,
//       select:(data)=>{
//           let rawdata=data?.data;
//            return rawdata
//       }
//   })
// }

  //  const useGetIndexDetail = (userData:any) => {
  //   return useQuery(
  //     [
  //       // "getAllCategoriesTenantId",
  //        userData],
  //     getIndexDetail,
  //     {
  //       enabled: !!userData,
  //       cacheTime: Infinity,
  //       refetchOnWindowFocus: false,
  //       onSuccess: (data) => {
  //         //    console.log(data)
  //       },
  //       onError: (err: any) => {
  //         //    console.log(err)
  //       },
  //       select: (data: any) => {
  //         let rawData = data?.data;
  //         // let tranFormed;
  //         // if (rawData) {
  //         //   tranFormed = rawData.map(({ name, id }: option) => {
  //         //     return { key: name, value: id };
  //         //   });
  //         // }
  //         return rawData;
  //       },
  //     }
  //   );
  // };

  const useGetIndexDetail=(tenantId: string | null)=>{
    return useQuery(['getIndexDetail', tenantId],getIndexDetail,{
      enabled: !!tenantId,
        refetchOnWindowFocus:false,
        cacheTime:Infinity,
        onError:(err)=>{
        },
        onSuccess:(data)=>{
            // let rawdata=data?.data?.data;
        }
        ,
        select:(data)=>{
            let rawdata=data?.data;
             return rawdata
        }
    })
}

   const useGetAllCategoriesTenantId = (tenantId: string | null) => {
    return useQuery(
      ["getAllCategoriesTenantId", tenantId],
      getAllCategoriesTenantId,
      {
        enabled: !!tenantId,
        cacheTime: Infinity,
        refetchOnWindowFocus: false,
        onSuccess: (data) => {
          //    console.log(data)
        },
        onError: (err: any) => {
          //    console.log(err)
        },
        select: (data: any) => {
          let rawData = data?.data;
          // let tranFormed;
          // if (rawData) {
          //   tranFormed = rawData.map(({ name, id }: option) => {
          //     return { key: name, value: id };
          //   });
          // }
          return rawData;
        },
      }
    );
  };
  
  const useAddCategory=()=>{
    const queryClient=useQueryClient()
    return useMutation({
  mutationFn: (userData:any) =>addCategory(userData),
  onSuccess: (data:any) => {
    queryClient.invalidateQueries('getAllCategoriesTenantId')
  },
});
   }

   const useEditCategory=()=>{
    const queryClient=useQueryClient()
    return useMutation({
  mutationFn: (userData:any) =>editCategory(userData),
  onSuccess: (data:any) => {
    queryClient.invalidateQueries('getAllCategoriesTenantId')
  },
});
   }

  const useGetBank=(tenantId: string | null)=>{
    return useQuery(['getBank', tenantId],getBank,{
      enabled: !!tenantId,
        refetchOnWindowFocus:false,
        cacheTime:Infinity,
        onError:(err)=>{
        },
        onSuccess:(data)=>{
            // let rawdata=data?.data?.data;
        }
        ,
        select:(data)=>{
            let rawdata=data?.data;
             return rawdata
        }
    })
}

const useDeleteCategory=()=>{
  const queryClient=useQueryClient()
    return useMutation({
  mutationFn: (data:any) =>deleteCategory(data),
  onSuccess: (data) => {
      queryClient.invalidateQueries('getAllCategoriesTenantId')
  },
});
}

const useDeleteIndex=()=>{
  const queryClient=useQueryClient()
    return useMutation({
  mutationFn: (data:any) =>deleteIndex(data),
  onSuccess: (data) => {
      queryClient.invalidateQueries('getAll')
  },
});
}

const useAcceptIndex=()=>{
    const queryClient=useQueryClient()
      return useMutation({
    mutationFn: (data:any) =>acceptIndex(data),
    onSuccess: (data) => {
        queryClient.invalidateQueries('getAll')
    },
  });
  }

export{
    useGetAll,
    useDeleteCategory,
    useGetAllCategoriesTenantId,
    useAddIndex,
    useGetIndexDetail,
    useAddCategory,
    useDeleteIndex,
    useEditCategory,
    useGetAllCategory,
    useEditIndex,
    useAcceptIndex,
    useGetBank
}